import {
  ContentWrapper,
  Footer,
  FormWrapper,
  Wrapper,
} from "./styled";

import logo from 'images/Logo.png'

import React, { useContext } from "react";
import { Avatar, Button, Flex, Form, Input, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { authAPI, useLoginMutation } from "../../redux/slices/auth";
import { UserContext } from "services/contexts";
import { COLORS, TYPOGRAPHY_SIZES } from "../../theme/constants";
import { Text } from "theme/typography";
import { MdOutlineEmail } from "react-icons/md";
import { BiLockAlt } from "react-icons/bi";

const Login: React.FC = (props) => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const { setUser } = useContext(UserContext);
  const [loginFn, { isLoading: isLoginLoading }] = useLoginMutation();
  const [getCurrentUser, { isLoading: loadingGetCurrentUser }] =
    authAPI.endpoints?.getCurrentUser?.useLazyQuery();

  const onFinish = async (values: any) => {
    try {
      const accessData = await loginFn({
        username: values.email,
        password: values.password,
      }).unwrap();
      if (accessData) {
        localStorage.setItem("AccessToken", accessData.access as string);
        localStorage.setItem("isAuthenticated", JSON.stringify(true));
        const userRaw = await getCurrentUser(
          accessData.access as string
        ).unwrap();
        setUser(userRaw);
        localStorage.setItem("user", JSON.stringify(userRaw));
        navigate("/");
      }
    } catch (e) {
      api["error"]({
        message: "Authentication Error",
        description: "Please check your credentials",
      });
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  type FieldType = {
    email?: string;
    password?: string;
    remember?: string;
  };

  return (
    <Wrapper>
      {contextHolder}
      <ContentWrapper>
        <Flex
          vertical={true}
          align={"center"}
          justify={"center"}
          gap={"middle"}
        >
          <img src={logo} alt='logo' width={300}/>
          <Flex vertical={true} align={"center"}>
            <Text size={TYPOGRAPHY_SIZES.NORMAL}>
              Electric Machine Design Solutions
            </Text>
          </Flex>
        </Flex>

        <FormWrapper bordered={false}>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item<FieldType>
              name="email"
              label={<strong>Email</strong>}
              rules={[
                { type: "email", message: "Invalid email" },
                { required: true, message: "Please input your email" },
              ]}
            >
              <Input
                placeholder="user@email.com"
                prefix={<MdOutlineEmail color={COLORS.colorGraySecondary} />}
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="password"
              label={<strong>Password</strong>}
              rules={[
                { required: true, message: "Please input your password" },
              ]}
            >
              <Input.Password
                placeholder="••••••••"
                prefix={<BiLockAlt color={COLORS.colorGraySecondary} />}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: 50 }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                loading={isLoginLoading || loadingGetCurrentUser}
              >
                Login
              </Button>
            </Form.Item>
          </Form>
        </FormWrapper>
        <Footer>
          Electric Motor: Diagnostics & Analysis @
          {new Date().getFullYear()}
        </Footer>
      </ContentWrapper>
    </Wrapper>
  );
};

export default Login;
